import { VUE_APP_SERVER_ADDRESS } from '@/application.config';

/**
 * URL of the benchWAVE application, carrying a cache-invalidating token.
 *
 * benchWAVE is served from the same origin under `/benchwave/`, so the iframe
 * shares `sessionStorage` (the hosting route writes `hotelUuid` there) and the
 * Keycloak SSO session with FO-v2.
 *
 * The token is computed on every call — i.e. when the hosting component is
 * mounted — so the URL never has a cache entry and the iframe document is
 * always fetched from the server. Hashed chunks stay cacheable, because only
 * the document URL changes.
 *
 * FO-v2 has no `<keep-alive>` (the single `<router-view />` lives in
 * `src/root/root.vue`), so entering a view remounts its component and
 * `setup()` produces a fresh token.
 *
 * The URL is fixed — benchWAVE routes internally, so unlike `v3Url` this helper
 * takes no path segment.
 */
export const benchwaveUrl = (): string => `${VUE_APP_SERVER_ADDRESS}/benchwave/?t=${Date.now()}`;
